import React from "react";
import { createRoot } from "react-dom/client";
import App from './App';

import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import BugsnagPerformance from '@bugsnag/browser-performance'
import { Provider } from "react-redux";
import { CookiesProvider } from 'react-cookie';
import store from './store'

Bugsnag.start({
  apiKey: '59294040620b333fde526c66c3544979',
  plugins: [new BugsnagPluginReact()]
})
BugsnagPerformance.start({ apiKey: '59294040620b333fde526c66c3544979' })
const bugsnagReactPlugin = Bugsnag.getPlugin('react')
if (bugsnagReactPlugin == null) throw new Error('bugsnagReactPlugin is null')
const ErrorBoundary = bugsnagReactPlugin.createErrorBoundary(React)


const rootElement = document.getElementById('root')
if (rootElement != null) {
  const root = createRoot(rootElement)

  root.render(
    <ErrorBoundary>
      <React.StrictMode>
        <CookiesProvider>
          <Provider store={store}>
            <App />
          </Provider>
        </CookiesProvider>
      </React.StrictMode>
    </ErrorBoundary>
  )
}